import styled from 'styled-components';
import { Spin } from 'antd';

export const TagGrid = styled('div')`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    max-height: calc(3 * 36px);
    gap: 4px 24px;
`;

export const TagRow = styled('div')`
    display: flex;
    align-items: center;
    height: 32px;
`;

export const TagsSectionSpinner = styled(Spin)`
    top: 0 !important;
`;